import React from "react";
import "@iventis/mapbox-gl/dist/mapbox-gl.css";
import { DrawToolBarComponent } from "@iventis/map-control-components/src/draw-toolbar";
import { ToolBarButton } from "@iventis/map-control-components/src/draw-toolbar-buttons";
import { toolbarButton, main as theme } from "@iventis/styles";

export function ClippingModeControls({ onDrawClicked }: { onDrawClicked: () => void }) {
    return (
        <div>
            <DrawToolBarComponent position={{ top: "140px", translateX: "20px" }} boxShadowColour="#000000">
                <ToolBarButton
                    icon={["far", "draw-polygon"]}
                    action={onDrawClicked}
                    tooltipHeader="Draw"
                    selected={false}
                    text="Draw"
                    colour={theme.typographyColors.core}
                    hoverColour={theme.tertiaryColors.primaryBackground}
                    hoverSelectedColour={theme.typographyColors.core}
                    disabled={false}
                    selectedColour={theme.typographyColors.core}
                    disabledColour={theme.shades.three}
                    selectedBackgroundColour={theme.secondaryColors.blank}
                    buttonWidth={toolbarButton}
                    buttonHeight={toolbarButton}
                />
            </DrawToolBarComponent>
        </div>
    );
}
